import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=5f33d78a&"
import script from "./BaseSelect.js?vue&type=script&lang=js&"
export * from "./BaseSelect.js?vue&type=script&lang=js&"
import style0 from "./BaseSelect.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports